
export function reverseArr(arr) {
    return [...arr].reverse();
}